import { Component, inject, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { FormField, form, required, min, maxLength } from '@angular/forms/signals';
import { ReservaApiService } from '@core/services/api/reserva-api.service';
import { IReservaRecursoData } from '@core/interfaces/entidades/reserva.entidad';
import { ToastService } from '@shared/services/toast.service';

import { UiButton } from '@shared/components/ui';

@Component({
  selector: 'app-crear-recurso',
  imports: [FormField, UiButton],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './crear-recurso.html',
})
export class CrearRecurso {
  private api = inject(ReservaApiService);
  private toast = inject(ToastService);

  readonly cerrar = output<IReservaRecursoData | undefined>();

  formRecurso = form(
    signal({
      nombre: '',
      descripcion: '',
      duracion_minutos: 60,
      precio: 0,
      capacidad: 1,
    }),
    (schema) => {
      required(schema.nombre, { message: 'El nombre es obligatorio' });
      maxLength(schema.nombre, 150, { message: 'Máximo 150 caracteres' });
      required(schema.duracion_minutos, { message: 'La duración es obligatoria' });
      min(schema.duracion_minutos, 1, { message: 'Mínimo 1 minuto' });
      required(schema.precio, { message: 'El precio es obligatorio' });
      min(schema.precio, 0, { message: 'El precio no puede ser negativo' });
      required(schema.capacidad, { message: 'La capacidad es obligatoria' });
      min(schema.capacidad, 1, { message: 'Mínimo 1' });
    },
  );

  onCerrar(data?: IReservaRecursoData) {
    this.cerrar.emit(data);
  }

  guardar() {
    if (this.formRecurso().invalid()) {
      this.formRecurso.nombre().markAsTouched();
      return;
    }
    const { nombre, descripcion, duracion_minutos, precio, capacidad } =
      this.formRecurso().controlValue();
    this.api
      .crearRecurso({
        nombre,
        descripcion: descripcion || null,
        duracion_minutos,
        precio,
        capacidad,
      })
      .subscribe({
        next: (data) => {
          this.toast.show('top-right', 'success', 'Éxito', 'Recurso creado correctamente');
          this.onCerrar(data);
        },
        error: (err) => {
          if (err.status === 401) return;
          this.toast.show(
            'top-right',
            'error',
            'Error',
            err.error?.message ?? 'No se pudo crear el recurso',
          );
        },
      });
  }
}
